module.exports = __webpack_public_path__ + "static/img/4.8e2221d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Personas/4.png
// module id = aL/z
// module chunks = 0